const messages = {
    heading: "404",
    lead: "Sorry, we couldn't find that page.",
    homeLink: "Go back home",
};

export default messages;
